import { EVENT_SOURCE, SEARCH_DIALOG_EVENT_SOURCE } from '../../constants/analytics';
import type { SearchStoreExperience } from '../../constants/search';
import { SearchExperience } from '../../constants/search-experience';
import type { FireAnalyticsEvent } from '../../types';

type OnSmartLinkUsageFetchSuccessArgs = {
	cloudId: string;
	experience: SearchStoreExperience;
	productCount: number;
	usages?: Record<string, number>;
};

// Fires when the Smart Link usage data is successfully fetched from the TAP delivery API
export const onSmartLinkUsageFetchSuccess = ({
	cloudId,
	experience,
	productCount,
	usages,
}: OnSmartLinkUsageFetchSuccessArgs): FireAnalyticsEvent => {
	return {
		action: 'taskSuccess',
		actionSubject: 'smartLinkUsageFetch',
		eventType: 'operational',
		source: experience === SearchExperience.QUICK_FIND ? SEARCH_DIALOG_EVENT_SOURCE : EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				cloudId,
				productCount,
				usages: usages ? JSON.stringify(usages) : undefined,
			},
		},
	};
};

type OnSmartLinkUsageFetchFailArgs = {
	cloudId: string;
	experience: SearchStoreExperience;
	reason: string;
};

// Fires when the Smart Link usage data fetch from the TAP delivery API fails
export const onSmartLinkUsageFetchFail = ({
	cloudId,
	experience,
	reason,
}: OnSmartLinkUsageFetchFailArgs): FireAnalyticsEvent => {
	return {
		action: 'taskFail',
		actionSubject: 'smartLinkUsageFetch',
		eventType: 'operational',
		source: experience === SearchExperience.QUICK_FIND ? SEARCH_DIALOG_EVENT_SOURCE : EVENT_SOURCE,
		attributes: {
			additionalAttributes: {
				cloudId,
				reason,
			},
		},
	};
};
